import * as THREE from "three";
import { Tutorial } from "./Tutorial.js";

export class TitleScreen {
  constructor(container, game) {
    if (!game) {
      throw new Error("Game instance must be provided to TitleScreen");
    }
    this.container = container;
    this.game = game;
    this.tutorial = null;
    this.startGameCallback = null;
    this.createTitleScreen();
  }

  createTitleScreen() {
    // Create title screen container
    this.element = document.createElement("div");
    this.element.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.8);
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      z-index: 1000;
    `;

    // Create title
    const title = document.createElement("h1");
    title.textContent = "Chakras";
    title.style.cssText = `
      color: #FFD700;
      font-size: 48px;
      margin: 0 0 10px 0;
      font-family: "Philosopher", sans-serif;
      text-shadow: 0 0 20px rgba(255, 215, 0, 0.5);
    `;

    // Create subtitle
    const subtitle = document.createElement("p");
    subtitle.textContent = "Connect the crystals, restore the balance";
    subtitle.style.cssText = `
      color: white;
      font-size: 16px;
      margin: 0 0 40px 0;
      font-family: "Philosopher", sans-serif;
      text-shadow: 0 0 10px rgba(255, 255, 255, 0.5);
      white-space: nowrap;
      text-align: center;
    `;

    // Create start button
    const startButton = document.createElement("button");
    startButton.textContent = "Start Game";
    startButton.style.cssText = `
      font-size: 24px;
      padding: 15px 40px;
      border-radius: 30px;
      border: 2px solid #FFD700;
      background-color: transparent;
      color: #FFD700;
      cursor: pointer;
      transition: all 0.3s ease;
      font-family: "Philosopher", sans-serif;
    `;

    // Button hover effect
    startButton.onmouseover = () => {
      startButton.style.backgroundColor = "#FFD700";
      startButton.style.color = "black";
      startButton.style.transform = "scale(1.1)";
    };
    startButton.onmouseout = () => {
      startButton.style.backgroundColor = "transparent";
      startButton.style.color = "#FFD700";
      startButton.style.transform = "scale(1)";
    };

    // Button click handler
    startButton.onclick = () => {
      if (this.onStartGame) {
        this.startTutorial();
      }
    };

    // Add elements to the container
    this.element.appendChild(title);
    this.element.appendChild(subtitle);
    this.element.appendChild(startButton);
    this.container.appendChild(this.element);
  }

  show() {
    if (this.element) {
      // Reset styles
      this.element.style.transition = "";
      this.element.style.opacity = "1";
      this.element.style.display = "flex";
    }
  }

  hide() {
    if (this.element) {
      // Add fade out animation
      this.element.style.transition = "opacity 0.5s ease-out";
      this.element.style.opacity = "0";

      // Remove element after animation completes
      setTimeout(() => {
        this.element.style.display = "none";
        // Reset opacity for next time
        this.element.style.opacity = "1";
      }, 500);
    }
  }

  setStartGameCallback(callback) {
    this.onStartGame = callback;
  }

  isTutorialActive() {
    return this.tutorial && this.tutorial.isActive;
  }

  startTutorial() {
    this.hide();
    this.tutorial = new Tutorial(
      this.game,
      this.game.grid,
      this.game.uiManager
    );
    this.tutorial.start();
  }
}
